import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=72f064a2&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"
import style0 from "./Time.vue?vue&type=style&index=0&id=72f064a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f064a2",
  null
  
)

component.options.__file = "Time.vue"
export default component.exports